/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import WebTileLayer from '@arcgis/core/layers/WebTileLayer';
import {LayerSettingsProps} from './LayerSettings';
import WeatherLayerSettings from './WeatherLayerSettings';

export type WeatherLayerContainerProps = LayerSettingsProps & {
  onOpacityChange: Function;
  onToggleExpand?: Function;
  opacity: number;
  url: string;
  expandedLayer: string
};

/**
 * @WeatherLayerTracking2Container
 *
 * The Weather Layer Container provides a component which allows to instantiate
 * the wheather Layer and Map Layer Setting.
 *
 * ```typescript
 *
 *   <WeatherLayerTracking2Container url={}
 *     isEnabled={}
 *     onToggle={}
 *     onOpacityChange={}
 *     opacity={}
 *     map={} />
 *
 * ```
 */
export const WeatherLayerTracking2Container = ({
  map,
  url,
  layers,
  onToggle,
  onOpacityChange,
  onToggleExpand,
  opacity,
  isEnabled,
  expandedLayer
}: WeatherLayerContainerProps) => {
  return (
    <WeatherLayerSettings webTileLayer={WebTileLayer as any}
      isEnabled={isEnabled}
      url={url}
      onToggle={onToggle}
      onToggleExpand={onToggleExpand}
      onOpacityChange={onOpacityChange}
      opacity={opacity}
      layers={layers}
      map={map}
      expandedLayer={expandedLayer}/>
  );
};

export default WeatherLayerTracking2Container;
